import { render, staticRenderFns } from "./addTargetDialog.vue?vue&type=template&id=680c0b7f"
import script from "./addTargetDialog.vue?vue&type=script&lang=js"
export * from "./addTargetDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports